import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { Reveal, MaskedLines } from "@/components/Reveal";

export function Overline({ children, className = "" }) {
  return (
    <span className={`overline inline-flex items-center gap-3 text-navy/60 ${className}`}>
      <span className="w-8 h-px bg-gold" />
      {children}
    </span>
  );
}

export function CTAPrimary({ to, children, testId, href }) {
  const cls =
    "group inline-flex items-center gap-3 bg-navy text-warm px-8 py-4 text-sm tracking-wide hover:bg-navy/90 transition-colors duration-300";
  const inner = (
    <>
      {children}
      <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
    </>
  );
  if (href) return <a href={href} className={cls} data-testid={testId}>{inner}</a>;
  return <Link to={to} className={cls} data-testid={testId}>{inner}</Link>;
}

export function CTASecondary({ to, children, testId }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className="group inline-flex items-center gap-3 border border-navy text-navy px-8 py-4 text-sm tracking-wide hover:bg-navy hover:text-warm transition-colors duration-300"
    >
      {children}
      <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
    </Link>
  );
}

// Editorial page header used on interior pages
export function PageHero({ label, lines, intro }) {
  return (
    <section className="pt-40 md:pt-52 pb-16 md:pb-24 border-b hairline">
      <div className="mx-auto max-w-[1500px] px-6 md:px-10">
        <Reveal><Overline>{label}</Overline></Reveal>
        <h1 className="mt-8 font-heading font-light text-navy text-[2.7rem] leading-[1.02] md:text-7xl lg:text-[5.2rem] tracking-tight">
          <MaskedLines lines={lines} delay={0.05} />
        </h1>
        {intro && (
          <Reveal delay={0.2}>
            <p className="mt-10 max-w-2xl text-lg md:text-xl leading-relaxed text-ink/70 font-body">{intro}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}

export function SectionShell({ children, className = "", id }) {
  return (
    <section id={id} className={`mx-auto max-w-[1500px] px-6 md:px-10 ${className}`}>
      {children}
    </section>
  );
}
